import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      authRequired: false,
      title:'博瑞特采购报价平台'
    },
    children:[
      {
        path: '/orderList',
        name: 'orderList',
        component: () => import('../views/offer/orderList.vue'),
        meta: {
          authRequired: false
          ,title:'报价列表'
        }
      },
      {
        path: '/log',
        name: 'log',
        component: () => import('../views/offer/log.vue'),
        meta: {
          authRequired: false
          ,title:'报价记录'
        }
      },
      {
        path: '/orderDetail',
        name: 'orderDetail',
        component: () => import('../views/offer/detail.vue'),
        meta: {
          authRequired: false
          ,title:'报价详情'
        }
      }
    ]
  },{
    path:'/reg',
    name:'reg',
    component: () => import('../views/user/Reg.vue'),
    meta: {
      authRequired: false
      ,title:'注册'
    }
  },{
    path:'/edit-my',
    name:'edit-my',
    component: () => import('../views/user/edit.vue'),
    meta: {
      authRequired: false
      ,title:'资料修改'
    }
  },{
    path:'/contact',
    name:'contact',
    component: () => import('../views/page/Contact.vue'),
    meta: {
      authRequired: false
      ,title:'联系我们'
    }
  },{
    path:'/news',
    name:'news',
    component: () => import('../views/news/list.vue'),
    meta: {
      authRequired: false
      ,title:'联系我们'
    }
  },{
    path:'/news-content',
    name:'news-content',
    component: () => import('../views/news/news-content.vue'),
    meta: {
      authRequired: false
      ,title:'联系我们'
    }
  }
]

const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


//页面刷新重新赋值
if (window.localStorage.getItem('hasLogin')) {
  store.commit("refreshPage")
}


//全局守卫
router.beforeEach((to, from, next) => {
  if(to.meta.title)  document.title = to.meta.title

  if (to.meta.authRequired) { //需要权限登录的页面
    if (store.state.hasLogin) {
      next();
    } else {
      next({
        path: '/home'
      });
    }

  } else if (to.path === '/login') {  //登录页面也需要处理
    if (store.state.hasLogin) {
      next({
        path: '/'
      });
    } else {
      next();
    }

  } else { //正常通行
    next();
  }

})

export default router;






